import React, { useState, useEffect } from 'react';
import { Spinner, Alert } from 'react-bootstrap';
import { API_URL } from '../../../config';
import { useAppData } from '../AppDataContext';
import { useLocation } from 'react-router-dom';
import { useResponsiveStyles } from './useResponsiveStyles';


const BlogPostBody = ({ styles = {} }) => {

  const appliedStyles = useResponsiveStyles(styles);

  const { subdomain } = useAppData();
  const location = useLocation();
  const urlSegments = location.pathname.split('/');
  const effectivePostId = urlSegments[urlSegments.length - 1];
  const [content, setContent] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    console.log("Effective postId:", effectivePostId);
  }, [effectivePostId]);

  useEffect(() => {
    if (!effectivePostId || !subdomain) return;
    setLoading(true);
    fetch(`${API_URL}/blog-post?account_key=${subdomain}&post_id=${effectivePostId}`)
      .then((res) => {
        if (!res.ok) {
          throw new Error('Failed to fetch blog post data.');
        }
        return res.json();
      })
      .then((data) => {
        // Extract content from data.data.content based on API response format.
        setContent(data.data.content);
        setLoading(false);
      })
      .catch((err) => {
        setError(err.message);
        setLoading(false);
      });
  }, [effectivePostId, subdomain]);

  if (loading) return <Spinner animation="border" size="sm" />;
  if (error) return <Alert variant="danger">{error}</Alert>;

  // If your content is HTML, you may use dangerouslySetInnerHTML to render it.
  return <div style={appliedStyles.container}><div dangerouslySetInnerHTML={{ __html: content }} /></div>;
};

export default BlogPostBody;
